<template>
  <div class="unit-card__alert-bottom l100">
    <span class="unit-card__alert-bottom-content" :id="`tooltip-l100-alert-${code}`">
      Level 100 units exceed 30 credits <i class="far fa-info-circle"></i>
    </span>

    <b-tooltip :target="`tooltip-l100-alert-${code}`" triggers="hover" placement="right" noninteractive>
      The total credit points for level 100 units across all components of the Course cannot exceed 30. Please remove level 100 units from the General Electives
      and select Level 200 or 300 instead.
    </b-tooltip>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UnitCardErrorL100',
  props: {
    code: {
      type: String,
      required: true
    }
  }
}
</script>
